var render = function render(){var _vm=this,_c=_vm._self._c;return _c('billing-report-panel',{attrs:{"report-key":"appeals-deadline","route":"/reports/billing-appeals-deadline","file-name":"prazos-de-recurso.xlsx","columns":_vm.columns,"show-professional":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }